import { FlagVariants } from "@kamae-apps/shared/Components/Fondations/Flags/Flags"
import { ReactNode } from "react"
export const flagsDictionary: Record<FlagVariants, ReactNode> = Object.freeze({
  fr: (
    <>
      <g clipPath="url(#clip0_5625_2318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 0H16V12H11V0Z"
          fill="#F50100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H5V12H0V0Z"
          fill="#2E42A5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0H11V12H5V0Z"
          fill="#F7FCFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_5625_2318">
          <rect
            width="16"
            height="12"
            rx="1"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  ),
  en: (
    <>
      <g clipPath="url(#clip0_5625_2207)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="#2E42A5"
        />
        <mask
          id="mask0_5625_2207"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="12"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V12H16V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_5625_2207)">
          <path
            d="M-1.78156 11.1427L1.73929 12.6317L16.0799 1.6189L17.9371 -0.593837L14.172 -1.09151L8.32284 3.65422L3.61484 6.85174L-1.78156 11.1427Z"
            fill="white"
          />
          <path
            d="M-1.29956 12.1859L0.494147 13.05L17.2702 -0.799421H14.7516L-1.29956 12.1859Z"
            fill="#F50100"
          />
          <path
            d="M17.7816 11.1427L14.2607 12.6317L-0.0798779 1.6189L-1.93704 -0.593837L1.82799 -1.09151L7.67719 3.65422L12.3852 6.85174L17.7816 11.1427Z"
            fill="white"
          />
          <path
            d="M17.6614 11.8914L15.8677 12.7555L8.72433 6.82582L6.60646 6.16331L-2.11576 -0.586292H0.402819L9.12014 6.0031L11.4356 6.79752L17.6614 11.8914Z"
            fill="#F50100"
          />
          <mask
            id="path-8-inside-1_5625_2207"
            fill="white"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.88888 -1H6.11111V4H-0.986237V8H6.11111V13H9.88888V8H17.0138V4H9.88888V-1Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.88888 -1H6.11111V4H-0.986237V8H6.11111V13H9.88888V8H17.0138V4H9.88888V-1Z"
            fill="#F50100"
          />
          <path
            d="M6.11111 -1V-2H5.11111V-1H6.11111ZM9.88888 -1H10.8889V-2H9.88888V-1ZM6.11111 4V5H7.11111V4H6.11111ZM-0.986237 4V3H-1.98624V4H-0.986237ZM-0.986237 8H-1.98624V9H-0.986237V8ZM6.11111 8H7.11111V7H6.11111V8ZM6.11111 13H5.11111V14H6.11111V13ZM9.88888 13V14H10.8889V13H9.88888ZM9.88888 8V7H8.88888V8H9.88888ZM17.0138 8V9H18.0138V8H17.0138ZM17.0138 4H18.0138V3H17.0138V4ZM9.88888 4H8.88888V5H9.88888V4ZM6.11111 0H9.88888V-2H6.11111V0ZM7.11111 4V-1H5.11111V4H7.11111ZM-0.986237 5H6.11111V3H-0.986237V5ZM0.0137634 8V4H-1.98624V8H0.0137634ZM6.11111 7H-0.986237V9H6.11111V7ZM7.11111 13V8H5.11111V13H7.11111ZM9.88888 12H6.11111V14H9.88888V12ZM8.88888 8V13H10.8889V8H8.88888ZM17.0138 7H9.88888V9H17.0138V7ZM16.0138 4V8H18.0138V4H16.0138ZM9.88888 5H17.0138V3H9.88888V5ZM8.88888 -1V4H10.8889V-1H8.88888Z"
            fill="white"
            mask="url(#path-8-inside-1_5625_2207)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5625_2207">
          <rect
            width="16"
            height="12"
            rx="1"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  ),
  es: (
    <>
      <g clipPath="url(#clip0_5625_2317)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="#FFB400"
        />
        <mask
          id="mask0_5625_2317"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="12"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V12H16V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_5625_2317)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V3H16V0H0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 9V12H16V9H0Z"
            fill="#C51918"
          />
          <rect
            x="2.504"
            y="5.13599"
            width="0.56"
            height="2.912"
            fill="#F1F9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.288 4.63208H2.28V4.91208H2.448V5.13608H3.12V4.91208H3.288V4.63208Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.12 8.21607H3.288V8.49607H2.28V8.21607H2.448V7.99207H3.12V8.21607Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.784 4.68802C2.90586 4.68802 2.91825 4.64213 2.99015 4.5736C3.04598 4.52038 3.176 4.45437 3.176 4.38002C3.176 4.20992 3.00049 4.07202 2.784 4.07202C2.5675 4.07202 2.392 4.20992 2.392 4.38002C2.392 4.46286 2.48154 4.51824 2.54924 4.5736C2.62057 4.63192 2.67293 4.68802 2.784 4.68802Z"
            fill="#AD1619"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.28 8.49597H3.288V8.94397C3.288 8.94397 3.162 8.88797 3.036 8.88797C2.91 8.88797 2.784 8.94397 2.784 8.94397C2.784 8.94397 2.658 8.88797 2.532 8.88797C2.406 8.88797 2.28 8.94397 2.28 8.94397V8.49597Z"
            fill="#005BBF"
          />
          <mask
            id="mask1_5625_2317"
            maskUnits="userSpaceOnUse"
            x="2"
            y="8"
            width="2"
            height="1"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.28 8.49597H3.288V8.94397C3.288 8.94397 3.162 8.88797 3.036 8.88797C2.91 8.88797 2.784 8.94397 2.784 8.94397C2.784 8.94397 2.658 8.88797 2.532 8.88797C2.406 8.88797 2.28 8.94397 2.28 8.94397V8.49597Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_5625_2317)" />
          <rect
            x="7.992"
            y="5.13599"
            width="0.56"
            height="2.912"
            fill="#F1F9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.77601 4.63208H7.76801V4.91208H7.93601V5.13608H8.60801V4.91208H8.77601V4.63208Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.60801 8.21607H8.77601V8.49607H7.76801V8.21607H7.93601V7.99207H8.60801V8.21607Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.272 4.68802C8.39387 4.68802 8.40626 4.64213 8.47815 4.5736C8.53398 4.52038 8.664 4.45437 8.664 4.38002C8.664 4.20992 8.4885 4.07202 8.272 4.07202C8.05551 4.07202 7.88 4.20992 7.88 4.38002C7.88 4.46286 7.96954 4.51824 8.03725 4.5736C8.10857 4.63192 8.16093 4.68802 8.272 4.68802Z"
            fill="#AD1619"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.76801 8.49597H8.77601V8.94397C8.77601 8.94397 8.65001 8.88797 8.52401 8.88797C8.39801 8.88797 8.27201 8.94397 8.27201 8.94397C8.27201 8.94397 8.14601 8.88797 8.02001 8.88797C7.89401 8.88797 7.76801 8.94397 7.76801 8.94397V8.49597Z"
            fill="#005BBF"
          />
          <mask
            id="mask2_5625_2317"
            maskUnits="userSpaceOnUse"
            x="7"
            y="8"
            width="2"
            height="1"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.76801 8.49597H8.77601V8.94397C8.77601 8.94397 8.65001 8.88797 8.52401 8.88797C8.39801 8.88797 8.27201 8.94397 8.27201 8.94397C8.27201 8.94397 8.14601 8.88797 8.02001 8.88797C7.89401 8.88797 7.76801 8.94397 7.76801 8.94397V8.49597Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_5625_2317)" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.49397 7.83994C2.59493 7.71754 2.65139 7.60618 2.65139 7.48791C2.65139 7.41334 2.6292 7.34893 2.59032 7.29631L2.59689 7.29336C2.59629 7.29363 2.70765 7.24509 2.74642 7.22649C2.8185 7.19194 2.882 7.15533 2.94391 7.11031C2.98343 7.08156 3.03639 7.05025 3.11712 7.0069L3.21347 6.95568C3.25271 6.93474 3.28193 6.9187 3.30907 6.90295C3.39365 6.85389 3.44955 6.81334 3.4923 6.75912C3.59356 6.63072 3.57254 6.45666 3.43064 6.36005C3.36112 6.31272 3.26731 6.28556 3.1298 6.26418L2.93312 6.23369C2.86731 6.22336 2.8086 6.21372 2.75624 6.20457C3.10052 6.14728 3.59214 6.16834 3.80839 6.27999L4.01392 5.88192C3.57325 5.65439 2.56918 5.67763 2.19412 5.93592C1.91902 6.12538 1.95593 6.41176 2.24216 6.53508C2.36176 6.58661 2.51767 6.6208 2.8062 6.66715C2.75785 6.6952 2.71776 6.72083 2.68041 6.74799C2.64253 6.77553 2.60195 6.79893 2.55273 6.82253C2.52919 6.83382 2.45949 6.86442 2.42753 6.87845L2.42751 6.87846L2.42751 6.87847L2.41145 6.88554C2.17831 6.99155 2.06516 7.1382 2.09897 7.40293L2.11727 7.54624L2.1501 7.55632L2.49397 7.83994ZM2.20578 7.4696L2.20507 7.47166L2.20561 7.4702L2.20578 7.4696ZM8.35297 7.48791C8.35297 7.60618 8.40943 7.71754 8.51039 7.83994L8.85425 7.55632L8.88709 7.54624L8.90539 7.40293C8.9392 7.1382 8.82605 6.99155 8.59291 6.88554L8.57685 6.87846C8.5449 6.86444 8.47518 6.83382 8.45163 6.82253C8.40241 6.79893 8.36182 6.77553 8.32395 6.74799C8.2866 6.72083 8.24651 6.6952 8.19816 6.66715C8.48668 6.6208 8.6426 6.58661 8.7622 6.53508C9.04843 6.41176 9.08534 6.12538 8.81024 5.93592C8.43518 5.67763 7.43111 5.65439 6.99044 5.88192L7.19597 6.27999C7.41222 6.16834 7.90384 6.14728 8.24812 6.20457C8.19576 6.21372 8.13705 6.22336 8.07124 6.23369L7.87456 6.26418C7.73705 6.28556 7.64324 6.31272 7.57372 6.36005C7.43182 6.45666 7.4108 6.63072 7.51206 6.75912C7.55481 6.81334 7.6107 6.85389 7.69529 6.90295C7.72243 6.9187 7.75165 6.93474 7.79089 6.95568L7.88724 7.0069C7.96797 7.05025 8.02093 7.08156 8.06045 7.11031C8.12236 7.15533 8.18586 7.19194 8.25794 7.22649C8.29671 7.24509 8.40807 7.29363 8.40747 7.29336L8.41404 7.29631C8.37516 7.34893 8.35297 7.41334 8.35297 7.48791Z"
            fill="#AD1619"
          />
          <path
            d="M2.96168 6.20007L3.12697 6.23427V6.48064C2.95092 6.62111 2.504 6.85786 2.504 6.85786V6.20007H2.96168Z"
            fill="#F1F9FF"
          />
          <path
            d="M8.15728 6.20007L7.99199 6.23427V6.48064C8.16804 6.62111 8.61496 6.85786 8.61496 6.85786V6.20007H8.15728Z"
            fill="#F1F9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.38801 3.60301V3.52102C7.09997 3.3143 6.79833 3.21094 6.4831 3.21094C6.18088 3.0772 5.87499 3.02529 5.5654 3.0552C5.56549 3.05424 5.56553 3.05376 5.56553 3.05376C5.10004 3.00821 4.63093 3.21094 4.63093 3.21094C4.15807 3.21094 3.72601 3.52102 3.72601 3.52102V3.60301L4.29083 4.17028C4.29083 4.17028 4.44975 4.71608 5.56264 4.58802C5.56303 4.58889 5.56323 4.58934 5.56323 4.58934C5.56323 4.58934 6.30041 4.56922 6.3522 4.55199C6.37276 4.54515 6.39407 4.53893 6.41585 4.53257C6.56024 4.49042 6.72508 4.44229 6.82319 4.17028L7.38801 3.60301ZM5.56287 3.08453C5.56054 3.11204 5.55685 3.15684 5.55248 3.21411C5.55802 3.17307 5.56174 3.13001 5.56287 3.08453Z"
            fill="#AD1619"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.75989 3.69923L3.79826 3.65845L4.31111 4.14095C4.40846 4.11477 4.93687 3.98012 5.52711 3.97349V3.97324L5.54957 3.9733L5.57202 3.97324V3.97349C6.22597 3.98084 6.80402 4.14533 6.80402 4.14533C6.80402 4.14533 6.79783 4.19841 6.78278 4.26081C6.79871 4.22814 6.81758 4.19184 6.8394 4.15178L6.8448 4.14478L7.36172 3.65845L7.40009 3.69923L6.88644 4.18249C6.8115 4.3205 6.77376 4.4116 6.77376 4.44944C6.77376 4.50717 6.62357 4.54144 6.33044 4.57663C6.1008 4.6042 5.82978 4.62271 5.60809 4.62548V4.62584L5.57999 4.62574L5.55189 4.62584V4.62548C5.3302 4.62271 5.05918 4.6042 4.82954 4.57663C4.53641 4.54144 4.38622 4.50717 4.38622 4.44944C4.38622 4.44228 4.38487 4.43322 4.38217 4.42229C4.35261 4.38465 4.33183 4.32307 4.318 4.26752C4.30502 4.24154 4.2902 4.21318 4.27354 4.18249L3.75989 3.69923ZM6.62653 4.45054C6.66576 4.4689 6.69721 4.45058 6.72208 4.41542C6.71993 4.42513 6.71858 4.43391 6.71804 4.44178C6.71476 4.44393 6.70972 4.44651 6.70311 4.44929C6.68466 4.45705 6.65649 4.46531 6.61985 4.47367C6.54781 4.4901 6.44528 4.50644 6.32376 4.52103C6.08647 4.54952 5.80431 4.56827 5.57999 4.56974C5.35567 4.56827 5.07351 4.54952 4.83622 4.52103C4.7147 4.50644 4.61217 4.4901 4.54014 4.47367C4.50942 4.46666 4.48465 4.45972 4.46658 4.4531L4.47261 4.45054C4.59495 4.39329 5.40389 4.33958 5.54957 4.33031C5.69525 4.33958 6.50419 4.39329 6.62653 4.45054ZM6.7808 4.44028L6.77995 4.44126L6.78046 4.44055L6.7808 4.44028Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.55612 2.67352C5.64891 2.67352 5.72412 2.59831 5.72412 2.50552C5.72412 2.41274 5.64891 2.33752 5.55612 2.33752C5.46334 2.33752 5.38812 2.41274 5.38812 2.50552C5.38812 2.59831 5.46334 2.67352 5.55612 2.67352Z"
            fill="#005BBF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.49343 2.03833H5.6101V2.11203H5.68633V2.2287H5.6101V2.46203H5.68633V2.5787H5.41602V2.46203H5.49343V2.2287H5.41602V2.11203H5.49343V2.03833Z"
            fill="#C88A02"
          />
          <rect
            x="5.47202"
            y="2.672"
            width="0.224"
            height="0.728"
            fill="#C88A02"
          />
          <path
            d="M3.85388 3.64843L3.54626 3.63686C3.6914 2.79807 4.40619 2.38708 5.5484 2.38708C6.69209 2.38708 7.40435 2.79985 7.53857 3.64176L7.12253 3.6854C7.05721 3.2757 6.37098 2.90493 5.55441 2.90493C4.73636 2.90493 3.92531 3.23561 3.85388 3.64843Z"
            fill="#C88A02"
          />
          <path
            opacity="0.3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.73599 4.63208H7.37599V7.9025C7.37599 7.9025 7.1056 9.00008 5.55599 9.00008C4.00638 9.00008 3.73599 7.87356 3.73599 7.87356V4.63208Z"
            fill="#E1E5E8"
          />
          <mask
            id="mask3_5625_2317"
            maskUnits="userSpaceOnUse"
            x="3"
            y="4"
            width="5"
            height="6"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.73599 4.63208H7.37599V7.9025C7.37599 7.9025 7.1056 9.00008 5.55599 9.00008C4.00638 9.00008 3.73599 7.87356 3.73599 7.87356V4.63208Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_5625_2317)">
            <rect
              x="3.73599"
              y="6.64807"
              width="1.848"
              height="2.184"
              fill="#FFC034"
            />
            <rect
              x="3.73599"
              y="4.57605"
              width="1.848"
              height="2.128"
              fill="#AD1619"
            />
            <rect
              x="5.52798"
              y="6.59204"
              width="1.848"
              height="2.128"
              fill="#AD1619"
            />
            <rect
              x="5.52798"
              y="4.63208"
              width="1.96"
              height="2.072"
              fill="#F1F9FF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.74136 8.72141C6.74136 8.72141 5.55526 8.81466 5.55526 8.04968C5.55526 8.04968 5.54395 8.72141 4.30545 8.72141V9.32532H6.74136V8.72141Z"
              fill="#F1F9FF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.55599 7.09607C5.78795 7.09607 5.97599 6.8955 5.97599 6.64807C5.97599 6.40065 5.78795 6.20007 5.55599 6.20007C5.32403 6.20007 5.13599 6.40065 5.13599 6.64807C5.13599 6.8955 5.32403 7.09607 5.55599 7.09607Z"
              fill="#005BBF"
              stroke="#AD1619"
              strokeWidth="0.583333"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.5 6C4.77614 6 5 5.77614 5 5.5C5 5.22386 4.77614 5 4.5 5C4.22386 5 4 5.22386 4 5.5C4 5.77614 4.22386 6 4.5 6Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 6C6.77614 6 7 5.77614 7 5.5C7 5.22386 6.77614 5 6.5 5C6.22386 5 6 5.22386 6 5.5C6 5.77614 6.22386 6 6.5 6Z"
            fill="#C37C9C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 8C6.77614 8 7 7.77614 7 7.5C7 7.22386 6.77614 7 6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8Z"
            fill="#FFC034"
          />
          <path
            d="M4.5 8C4.77614 8 5 7.77614 5 7.5C5 7.22386 4.77614 7 4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8Z"
            fill="#AD1619"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5625_2317">
          <rect
            width="16"
            height="12"
            rx="1"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  ),
  de: (
    <>
      <g clipPath="url(#clip0_5625_2201)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8H16V12H0V8Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4H16V8H0V4Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H16V4H0V0Z"
          fill="#272727"
        />
      </g>
      <defs>
        <clipPath id="clip0_5625_2201">
          <rect
            width="16"
            height="12"
            rx="1"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  ),
})
